<template>
  <div class="w-full px-6 py-4 border-0 rounded relative mb-4" :class="getCss">
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    getCss() {
      let style = ``;
      switch (this.variant) {
        case 'primary':
          style += 'text-white bg-blue-700 ';
          break;
        case 'info':
          style += 'text-blue-700 bg-blue-300 ';
          break;
        case 'warning':
          style += 'text-white bg-orange-500 ';
          break;
        case 'danger':
          style += 'text-white bg-red-500 ';
          break;
        case 'success':
          style += 'text-white bg-green-600 ';
          break;
        default:
          style += 'text-white bg-blue-500 ';
          break;
      }
      return style;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Alert.vue